export default __webpack_public_path__ + "static/media/dropdown_arrow.e3c54377.svg";